import { Component } from 'preact'
import CategorySelect from './CategorySelect'
import ArticlePreviewSettings from './ArticlePreviewSettings'
import Checkbox from './Checkbox'
import Attachments from '../category/control/Attachments'
import { DropdownSelectizeInput } from '../dropdown/DropdownSelectize'

export default class Sidebar extends Component {
  render (props) {
    const {
      error, forum_id, categories, allowReplies, sticky, featuredImage, tags, onUpdate, isKnowledgeBaseEnabled,
      articleId, isPreviewPublic, onShowArticlePreviewModal, onError, onSuccess
    } = props

    return (
      <div class='article-creator__sidebar category-add_container'>
        {articleId && <a
          href={`/article/${articleId}/versions`}
          class='article-creator__sidebar-versions'>Version History</a>
        }
        {articleId && <ArticlePreviewSettings
          articleId={articleId}
          isPublic={isPreviewPublic || false}
          onShowArticlePreviewModal={onShowArticlePreviewModal}
          onError={onError}
          onSuccess={onSuccess} />
        }
        <CategorySelect
          forum_id={forum_id}
          categories={categories}
          isKnowledgeBaseEnabled={isKnowledgeBaseEnabled}
          error={error}
          onUpdate={forumId => onUpdate('forum_id', forumId)}
        />
        {error && <span class='error'>{error}</span>}
        <div class='form-group'>
          <Checkbox
            label='Allow replies'
            onUpdate={status => onUpdate('open', status)}
            qaClasses='qa-open'
            checked={allowReplies}
          />
          <Checkbox
            label='Sticky topic'
            onUpdate={status => onUpdate('sticky', status)}
            qaClasses='qa-sticky'
            checked={sticky}
          />
        </div>
        <div class='form-group'>
          <label for='article-label'>Article Label</label>
          <DropdownSelectizeInput
            items={this.props.labels}
            class='js-public-label js-field form-control selectize-allow-input qa-public-label'
            placeholder='Add a label next to article title'
            selectedItem={this.state.public_label || this.props.public_label || ''}
            onChange={(label) => onUpdate('public_label', label)}
          />
        </div>
        <Attachments
          label='Featured Image'
          className='article-creator__sidebar-featured-image'
          meta={<div>Maximum file size: 5M. Allowed image types: .jpg, .jpeg, .png, .gif. We recommend a minimum of 1440*640px</div>}
          isAttachmentSelected={featuredImage !== ''}
          imageSrc={featuredImage || null}
          width={1440}
          height={640}
          onUpdate={data => onUpdate('featured_image', data ? data.source_thumb : null)}
        />
        <div>
          <label htmlFor='public-tags-label'>Public Tags</label>
          <DropdownSelectizeInput
            items={[]}
            single={false}
            class='form-control qa-article-creator-public-tags-input'
            placeholder='Add tags to help readers easily find this article'
            selectedItems={this.state.tags && this.state.tags.length ? this.state.tags : (tags || [])}
            onChange={(tags) => onUpdate('tags', tags)}
          />
        </div>
      </div>
    )
  }
}
